import capitalize from 'lodash/capitalize';
import { useSetRecoilState } from 'recoil';

import { useAuth } from '@chainlit/react-client';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';

import { userSidebarOpenState } from '@/state/project';

export default function UserNav() {
  const { user } = useAuth();
  const setSidebarOpen = useSetRecoilState(userSidebarOpenState);

  if (!user) return null;
  const displayName = user?.display_name || user?.identifier || '';
  const initial = displayName.charAt(0) || '?';
  const avatarSrc =
    typeof user?.metadata?.image === 'string'
      ? (user.metadata.image as string)
      : undefined;

  return (
    <Button
      id="user-nav-button"
      variant="ghost"
      onClick={() => setSidebarOpen(true)}
      title="Account & settings"
      aria-label="Open account and settings sidebar"
      className="relative h-8 w-8 rounded-full p-0"
    >
      <Avatar className="h-8 w-8">
        <AvatarImage src={avatarSrc} alt="user image" />
        <AvatarFallback className="bg-primary text-primary-foreground font-semibold">
          {capitalize(initial)}
        </AvatarFallback>
      </Avatar>
    </Button>
  );
}
